import React from 'react';
import styled from 'styled-components';
import Location from '../../assets/target.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';
import Jellyfish from '../../components/Jellyfish/Jellyfish';

const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:50vh;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

  
`;

class CardJellyfish extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
    
      <Jellyfish/>       
    
      
            
    </Viz>

      <ReusableDetailCard
   trend= {Location}
   metricsm="Prevalent Worldwide"
   diagnosis="Jellyfish are simple invertebrates which prey on small fish by using a venemous nettle. An elementary nervous system allows them to respond to light and smell, though movement is heavily influenced by the currents."
   prediction="The endangerment of Sea turtles, which control the population of jellies, could allow the invertebrates to decimate global fish stocks (NOAA)."
   significanceorthreat="THREAT"
   confidence="CONFICENCE LV: 95%"
   />
  </Container>
  );
 }
}

export default CardJellyfish;
